export default "/kiban/_next/static/images/roulette-e512e1fb54dc9931b4c8b77b1b133725.png";